import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getParentEdgeTypeId } from '@iotv/datamodel';
import { ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
import { Alert } from '@mui/material';
import { useEffect, useState } from 'react';
import { ConsumerDao } from '../../../data/ConsumerDAO';
import { getPartnersForEntityGroupsRegionQuery } from '../../../QueryDefinitions/partner';
import { AdjacentType, ComponentMode } from '../../../types';
import { Listerlizer } from '../../factories/Listerlizer/Listerlizer';
import { GroupViewDefinition } from '../Devices/DeviceGatewayGroupViewSubParts';
/** A listerlizer that find Partner -> Group links
 * Linkable items is populated based on a convoluated query from group to area to property to region to partners (and all partners in parent regions)
 * */
export const EntityGroupPartnerByRegionTab = ({ viewObject, userFunctions, transactionFunctions, columnVisibilityReferences, applicationData, }) => {
    /** Region Control */
    // TODO: warning if entity group is no longer in a region that one or more partners are in
    /** Query for Apex Partner Group (root for query to get linkable partners */
    const [apexPartnerGroup, setApexPartnerGroup] = useState(applicationData?.getNodesOfType('Group')?.find((p) => p.name === 'Apex Partners') ?? undefined);
    const [apexPartnerErrorDisplay, setApexPartnerErrorDisplay] = useState(undefined);
    useEffect(() => {
        if (apexPartnerGroup !== undefined)
            return;
        ConsumerDao.getApexGroupsOfSupportedType('Partner').then((apex_partner_res) => {
            if (apex_partner_res.err) {
                console.error(apex_partner_res.err);
                setApexPartnerErrorDisplay('An error occured finding partners. Error: apex_partner_res.err.message');
                return;
            }
            if (!apex_partner_res.data) {
                console.warn('EntityGroupPartnerTab', 'getApexGroupsOfSupportedType returned no err and no data. Have you pushed ConsumerDataAPI since July 15 2025?', apex_partner_res);
                setApexPartnerErrorDisplay('Could not find partners, please open developer console for more details.');
                return;
            }
            const apexPartnerGroup = apex_partner_res.data.find((p) => p.name === 'Apex Partners');
            if (!apexPartnerGroup) {
                console.warn('EntityGroupPartnerTab', 'failed to fetch Apex Partners, have you deployed base data since July 15 2025?', apex_partner_res);
                setApexPartnerErrorDisplay('Could not find partners, please open developer console for more details.');
                return;
            }
            setApexPartnerGroup(apexPartnerGroup);
        });
    }, [apexPartnerGroup]);
    // Get region
    /** Direct Links */
    const pr = viewObject.matchedPrimary && applicationData
        ? {
            autoQuery: false,
            adjacentFilter: {
                objectType: 'Partner',
                adjacentType: AdjacentType.PARENT,
                edgeFilter: {
                    edgeTypeId: getParentEdgeTypeId('Group', 'Partner'),
                    edgeAttributeFilters: [
                        { setOperation: LogicalOperatorType.AND, filters: [{ key: 'partnerViaRegion', predicate: ComparisonType.EQUALS, value: true }] },
                    ],
                },
                otherObjectType: 'Partner',
            },
            newLinkEdgeAttributes: {
                partnerViaRegion: true,
            },
            //searchAdjacentFilter: {
            //  objectType: 'Partner',
            //  adjacentType: AdjacentType.PARENT,
            //  edgeFilter: {
            //    edgeTypeId: getParentEdgeTypeId('Group', 'Partner')!, // Required or edge type fails on link... but causes auto query to fail......
            //  },
            //  otherObjectType: 'Partner',
            //},
            viewObject,
            userFunctions,
            transactionFunctions,
            viewDefinition: GroupViewDefinition,
            contextObject: viewObject.matchedPrimary,
            initMode: ComponentMode.EDIT,
            searchRootObjects: [viewObject.matchedPrimary],
            linkableItemsResultFilter: {
                objectTypeId: 'Partner',
                adjacencyType: AdjacentType.PARENT,
            },
            linkableItemsBranchingQueryDefinition: getPartnersForEntityGroupsRegionQuery(),
            applicationData,
        }
        : undefined;
    // TODO: make it so we display partners connected to parent groups of this group
    return (_jsxs(_Fragment, { children: [apexPartnerErrorDisplay && _jsx(Alert, { severity: "error", children: apexPartnerErrorDisplay }), apexPartnerGroup && pr && _jsx(Listerlizer, { ...pr })] }));
};
